import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, X } from "lucide-react";
import dealerApi from "../../utils/dealerApi";

const L = {
  IT: ["Manuale aggiornato", "Novità", "Apri il manuale", "Chiudi"],
  UK: ["Manual updated", "What's new", "Open the manual", "Dismiss"],
  FR: ["Manuel mis à jour", "Nouveautés", "Ouvrir le manuel", "Fermer"],
  ES: ["Manual actualizado", "Novedades", "Abrir el manual", "Cerrar"],
  DE: ["Handbuch aktualisiert", "Neuigkeiten", "Handbuch öffnen", "Schließen"],
  PT: ["Manual atualizado", "Novidades", "Abrir o manual", "Fechar"],
  NL: ["Handleiding bijgewerkt", "Wat is er nieuw", "Handleiding openen", "Sluiten"],
  PL: ["Instrukcja zaktualizowana", "Nowości", "Otwórz instrukcję", "Zamknij"],
  SE: ["Manualen uppdaterad", "Nyheter", "Öppna manualen", "Stäng"],
  NO: ["Håndboken oppdatert", "Nyheter", "Åpne håndboken", "Lukk"],
  FI: ["Käsikirja päivitetty", "Uutta", "Avaa käsikirja", "Sulje"],
  DK: ["Manualen opdateret", "Nyheder", "Åbn manualen", "Luk"],
  CZ: ["Příručka aktualizována", "Novinky", "Otevřít příručku", "Zavřít"],
  GR: ["Το εγχειρίδιο ενημερώθηκε", "Τι νέο υπάρχει", "Άνοιγμα εγχειριδίου", "Κλείσιμο"],
};
const ALIAS = { GBZ: "UK", IRL: "UK", BE: "FR", CH: "DE" };
export const manualUpdateLabels = (lang) => L[ALIAS[lang] || lang] || L.UK;

export const useManualUpdate = (token, lang) => {
  const [update, setUpdate] = useState(null);
  useEffect(() => {
    if (!token) return;
    dealerApi.get("/dealer/manual-updates/latest", { token, config: { headers: { "X-Dealer-Lang": (lang || "IT").toUpperCase() } } })
      .then((r) => setUpdate(r.data.update)).catch(() => setUpdate(null));
  }, [token, lang]);
  const dismiss = useCallback(() => {
    if (!update) return;
    setUpdate(null);
    dealerApi.post("/dealer/manual-updates/seen", { token }).catch(() => {});
  }, [token, update]);
  return { update, dismiss };
};

export const DealerManualUpdateBanner = ({ update, dismiss, lang }) => {
  if (!update) return null;
  const [title, news, open, close] = manualUpdateLabels(lang);
  const href = update.role === "seller" ? "/seller/manual" : "/dealer/manual";
  return (
    <div className="mb-6 bg-[#111] border border-lojack-red/40 rounded-xl p-4 flex gap-4 items-start" data-testid="dealer-manual-update-banner">
      <BookOpen className="text-lojack-red shrink-0 mt-0.5" size={20} />
      <div className="flex-1 min-w-0">
        <p className="text-white font-semibold text-sm">
          {title} · {new Date(update.approved_at).toLocaleDateString("it-IT")}
        </p>
        <p className="text-xs text-gray-400 mt-1">{news}:</p>
        <p className="text-sm text-gray-300 whitespace-pre-line mt-1" data-testid="dealer-manual-update-summary">{update.summary}</p>
        <Link to={href} onClick={dismiss} className="inline-block mt-3 text-sm text-lojack-red hover:underline" data-testid="dealer-manual-update-open">
          {open} →
        </Link>
      </div>
      <button onClick={dismiss} aria-label={close} title={close} className="text-gray-500 hover:text-white" data-testid="dealer-manual-update-dismiss">
        <X size={16} />
      </button>
    </div>
  );
};
